export default __webpack_public_path__ + "static/media/vevo-youtube.8197c22d.png";